<template>
    <div v-resize="onResize" class="fill-height" ref="container">
        <v-tabs
            ref="tabs"
            active-class="white"
            background-color="grey lighten-3"
            hide-slider
            show-arrows
        >
            <v-tab :to="{ name: 'shipping', params: { setting } }">
                Shipping
            </v-tab>
            <v-tab :to="{ name: 'finish', params: { setting } }">
                Finish
            </v-tab>
            <v-tab :to="{ name: 'profiles', params: { setting } }">
                Profiles
            </v-tab>
            <v-tab :to="{ name: 'role-assignments', params: { setting } }">
                Role Assignments
            </v-tab>
            <v-tab :to="{ name: 'value-inputs', params: { setting } }">
                Value Inputs
            </v-tab>
            <v-tab :to="{ name: 'louver-files', params: { setting } }">
                Louvers files
            </v-tab>
            <v-tab
                :to="{ name: 'louver-scope-descriptions', params: { setting } }"
            >
                Louver Descriptions
            </v-tab>
            <v-tab :to="{ name: 'acs-files', params: { setting } }">
                ACS Files
            </v-tab>
            <v-tab :to="{ name: 'client-portal-formats', params: { setting } }">
                Client Portal Formats
            </v-tab>
            <v-tab :to="{ name: 'videotutorial', params: { setting } }">
                VideoTutorial
            </v-tab>
        </v-tabs>
        <v-card :loading="loading" flat>
            <v-card-title ref="title">
                <v-btn
                    fab
                    depressed
                    @click="show"
                    icon
                    v-if="$vuetify.breakpoint.smAndDown"
                >
                    <v-icon size="36">
                        mdi-chevron-left
                    </v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text
                class="overflow-y-auto"
                :style="{ height: `${height}px` }"
            >
                <router-view />
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
    name: 'ClientSettings',
    props: {
        setting: Object,
    },
    data() {
        return {
            height: 0,
            loading: false,
        }
    },
    updated() {
        this.onResize()
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        show() {
            if (this.$vuetify.breakpoint.smAndDown) {
                this.$emit('show')
            }
        },
        onResize() {
            const {
                container: { clientHeight: containerHeight },
                tabs: {
                    $el: { clientHeight: tabsHeight },
                },
                title: { clientHeight: titleHeight },
            } = this.$refs
            this.height = containerHeight - tabsHeight - titleHeight
        },
    },
}
</script>
